'use client';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../buttons';
import { formatDescriptionHtml } from './helpers';
import { useToggle } from '@/hooks/common';

import {
  ScDescriptionAction,
  ScDescriptionContainer,
  ScDescriptionText,
} from './styled';
import { ScContainer, ScStaticPage } from '@/styles/common';

type ClientSeoDescriptionProps = {
  description?: string;
};

export const ClientSeoDescription = ({
  description,
  children,
}: PropsWithChildren<ClientSeoDescriptionProps>) => {
  const { t } = useTranslation('common');

  const [isExpanded, toggleExpand] = useToggle();

  return (
    <>
      {children}
      {description && (
        <ScStaticPage>
          <ScContainer>
            <ScDescriptionContainer isExpanded={isExpanded}>
              <ScDescriptionText
                dangerouslySetInnerHTML={{
                  __html: formatDescriptionHtml(description),
                }}
              />
              <ScDescriptionAction isExpanded={isExpanded}>
                <Button
                  small
                  paddingX={44}
                  whiteTransparent
                  onClick={toggleExpand}
                >
                  {isExpanded ? t('showLessLong') : t('showMore')}
                </Button>
              </ScDescriptionAction>
            </ScDescriptionContainer>
          </ScContainer>
        </ScStaticPage>
      )}
    </>
  );
};
